export default __webpack_public_path__ + "static/media/cloud.31c6173a.png";